import React, { Fragment } from 'react';
import get from 'lodash/get';
import { Link, useNavigate } from 'react-router-dom';
import { PageSubTitle } from 'Components/Titles';
import { CardInfo } from 'Components/CardInfo';
import { timestampToDate } from 'Utils/Format';
import { StubLabel } from 'Components/Texts';

export const ManageBilling = ({
  title,
  user,
  subscription,
  paymentMethods,
  hasPayments,
  trackEditAccount,
  routes,
  orders,
}) => {
  const navigate = useNavigate();
  const { purchaseType } = subscription;
  const { hasCardPayment, hasPaypalPayment, hasApplePayPayment, cardPayment, paypalPayment, showPaymentMethod } =
    paymentMethods;

  const receivedDate = get(orders, '[0].paymentsInfo[0].receivedDate');
  const lastPaymentDate = timestampToDate(receivedDate, 2);

  if (user.hasMvpd || purchaseType !== 'web' || (hasApplePayPayment && !hasPayments && !showPaymentMethod)) {
    return null;
  }

  return (
    <div className="sectionFlex billingSection">
      <div className="flexGrowOne settingsSectionLeft">
        <PageSubTitle text={title} />
      </div>
      <div className="sectionFlex flexDirCol flexGrowTwo settingsSectionRight editPaymentMethodSection">
        {showPaymentMethod && (
          <div className="sectionFlex">
            {hasCardPayment && showPaymentMethod == 'card' && (
              <>
                <div>
                  <CardInfo {...cardPayment} />
                </div>
                <div className="linksCol editPaymentLink">
                  <Link
                    to={routes.editPayment}
                    onClick={() => trackEditAccount('Edit Payment Info')}
                    className="profileLink text-right align-right"
                  >
                    <span className="manage">Edit </span>
                    <span>Payment Method</span>
                  </Link>
                </div>
              </>
            )}
            {hasPaypalPayment && showPaymentMethod == 'paypal' && (
              <Fragment>
                <div className="sectionFlex paypalContainer">
                  <img
                    className="paypalImg"
                    src="/account/static/images/cards/paypal-logo-01.svg"
                    width="73"
                    height="17"
                    alt="PayPal"
                  />
                  <div className="paypalTextContainer">
                    <span>{paypalPayment.email}</span>
                    <div className="sectionFlex paypalManageAccountMessage">
                      To manage your PayPal account, visit your PayPal account under "Payment settings".
                    </div>
                  </div>
                  <div className="flexGrowOne">
                    <Link
                      to={routes.editPayment}
                      onClick={() => trackEditAccount('Edit Payment Info')}
                      className="profileLink block text-right"
                    >
                      <span className="manage">Edit </span>
                      <span>Payment Method</span>
                    </Link>
                  </div>
                </div>
              </Fragment>
            )}
          </div>
        )}
        {!showPaymentMethod && (
          <div className="sectionFlex">
            <div></div>
            <div className="linksCol editPaymentLink">
              <Link
                to={routes.editPayment}
                onClick={() => trackEditAccount('Edit Payment Info')}
                className="profileLink text-right align-right"
              >
                <span className="manage">Edit </span>
                <span>Payment Method</span>
              </Link>
            </div>
          </div>
        )}
        {hasPayments && (
          <div className="sectionFlex sectionDivider infoRow">
            <div className="sectionFlex infoRowLeft">
              <StubLabel className="profileLabel" text="Billing History:" />
              <span className="stubValue">Last Payment on {lastPaymentDate}</span>
            </div>
            <div className="linksCol">
              <button
                onClick={() => {
                  trackEditAccount('Billing History');
                  navigate(routes.billingHistory);
                }}
                className="profileLink"
              >
                <span className="profileLinkTest">View Billing History</span>
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
